<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :height="320"
            :fixed-header="true"
            :search="search"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Empresa</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field 
                        class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn v-show="desserts.length == 0" color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.razao_social"
                                                autofocus
                                                label="Razao Social*"
                                                :error-messages="razaoSocialErrors"
                                                @input="$v.editedItem.razao_social.$touch()"
                                                @blur="$v.editedItem.razao_social.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.cnpj"
                                                label="CNPJ*"
                                                v-mask = maskCnpj
                                                style="margin-right: 5px"
                                                :error-messages="cnpjErrors"
                                                @input="$v.editedItem.cnpj.$touch()"
                                                @blur="$v.editedItem.cnpj.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.licencas"
                                                label="Numero de Licenca*"
                                                style="margin-left: 5px"
                                                :error-messages="licencaErrors"
                                                @input="$v.editedItem.licencas.$touch()"
                                                @blur="$v.editedItem.licencas.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.contrato"
                                                label="Contrato*"
                                                :error-messages="contratoErrors"
                                                @input="$v.editedItem.contrato.$touch()"
                                                @blur="$v.editedItem.contrato.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.data_inicio"
                                                type="date"
                                                label="Data Inicial*"
                                                style="margin-right: 5px"
                                                :error-messages="dataInicialErrors"
                                                @input="$v.editedItem.data_inicio.$touch()"
                                                @blur="$v.editedItem.data_inicio.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.data_fim"
                                                type="date"
                                                label="Data Final*"
                                                style="margin-left: 5px"
                                                :error-messages="dataFimErrors"
                                                @input="$v.editedItem.data_fim.$touch()"
                                                @blur="$v.editedItem.data_fim.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.filial_compra"
                                                :items="selects.compraFilial.items"
                                                chips
                                                label="Ativar Compra por Filial*"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                style="margin-left: 5px"
                                                :error-messages="compraFilialErrors"
                                                @input="$v.editedItem.filial_compra.$touch()"
                                                @blur="$v.editedItem.filial_compra.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.fator_atuacao"
                                                :items="selects.fatorAtuacao.items"
                                                chips
                                                label="Ativar Fator de Atuação*"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                style="margin-left: 5px"
                                                :error-messages="fatorAtuacaoErrors"
                                                @input="$v.editedItem.fator_atuacao.$touch()"
                                                @blur="$v.editedItem.fator_atuacao.$touch()"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save()">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:item.src_modulo="{ item }">
                <v-icon>{{item.src_modulo}}</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Módulo"
                    class="mr-2"
                    @click="editItem(item)"
                >
                mdi-pencil
                </v-icon>
            </template>
            <template v-slot:item.action_delete="{ item }">
                <v-icon
                    title="Remover Módulo"
                    @click="deleteItem(item)"
                >
                mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators'
    import Api from "./../../api/cfg";
        
    import Vue from 'vue'
    import { VueMaskDirective } from "v-mask";
    Vue.directive("mask", VueMaskDirective);

    export default {
        data: () => ({
            maskCnpj: "##.###.###/####-##",
            dialog: false,
            search: '',
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                },
                {
                    text: 'Razao Social',
                    align: 'left',
                    value: 'razao_social',
                },
                {
                    text: 'CNPJ',
                    align: 'left',
                    value: 'cnpj',
                },
                {
                    text: 'Numero Licenca',
                    align: 'left',
                    value: 'licencas',
                },
                {
                    text: 'Contrato',
                    align: 'left',
                    value: 'contrato',
                },
                {
                    text: 'Data Inicial',
                    align: 'left',
                    value: 'data_inicio',
                },
                {
                    text: 'Data Final',
                    align: 'left',
                    value: 'data_fim',
                },
                {
                    text: 'Compra Por Filial',
                    align: 'left',
                    value: 'filial_compra',
                },
                {
                    text: 'Fator Atuação',
                    align: 'left',
                    value: 'fator_atuacao',
                },
                {text: 'Ações', value: 'action', sortable: false},
                {text: '', value: 'action_delete', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                razao_social: '',
                cnpj: '',
                licencas: '',
                contrato: '',
                data_inicio: '',
                data_fim: '',
                filial_compra: '',
                fator_atuacao: ''
            },
            defaultItem: {
                id: '',
                razao_social: '',
                cnpj: '',
                licencas: '',
                contrato: '',
                data_inicio: '',
                data_fim: '',
                filial_compra: '',
                fator_atuacao: ''

            },
            selects: {
                empresas: {
                    items: [],
                },
                compraFilial: {
                    items: [
                        {id: 'S', value: 'SIM'},
                        {id: 'N', value: 'NÃO'}
                    ],
                },
                fatorAtuacao: {
                    items: [
                        {id: 'S', value: 'SIM'},
                        {id: 'N', value: 'NÃO'}
                    ],
                },
            }
        }),

        validations: {
            editedItem: {
                razao_social: {
                    required,
                },
                cnpj: {
                    required,
                },
                licencas: {
                    required,
                },
                contrato: {
                    required,
                },
                data_inicio: {
                    required,
                },
                data_fim: {
                    required,
                },
                filial_compra: {
                    required
                },
                fator_atuacao: {
                    required
                }
            }
        },
        
        computed: {
            razaoSocialErrors() {
                const errors = []
                if (!this.$v.editedItem.razao_social.$dirty) return errors
                !this.$v.editedItem.razao_social.required && errors.push('Campo Obrigatório.')
                return errors
            },
            cnpjErrors() {
                const errors = []
                if (!this.$v.editedItem.cnpj.$dirty) return errors
                !this.$v.editedItem.cnpj.required && errors.push('Campo Obrigatório.')
                return errors
            },
            licencaErrors() {
                const errors = []
                if (!this.$v.editedItem.licencas.$dirty) return errors
                !this.$v.editedItem.licencas.required && errors.push('Campo Obrigatório.')
                return errors
            },
            contratoErrors() {
                const errors = []
                if (!this.$v.editedItem.contrato.$dirty) return errors
                !this.$v.editedItem.contrato.required && errors.push('Campo Obrigatório.')
                return errors
            },
           dataInicialErrors() {
                const errors = []
                if (!this.$v.editedItem.data_inicio.$dirty) return errors
                !this.$v.editedItem.data_inicio.required && errors.push('Campo Obrigatório.')
                return errors
            },
           dataFimErrors() {
                const errors = []
                if (!this.$v.editedItem.data_fim.$dirty) return errors
                !this.$v.editedItem.data_fim.required && errors.push('Campo Obrigatório.')
                return errors
            },
           compraFilialErrors() {
                const errors = []
                if (!this.$v.editedItem.filial_compra.$dirty) return errors
                !this.$v.editedItem.filial_compra.required && errors.push('Campo Obrigatório.')
                return errors
            },
           fatorAtuacaoErrors() {
                const errors = []
                if (!this.$v.editedItem.fator_atuacao.$dirty) return errors
                !this.$v.editedItem.fator_atuacao.required && errors.push('Campo Obrigatório.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Nova Empresa' : 'Editar Empresa'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                Api.getEmpresas(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {
                            
                            this.desserts = response.data.empresas;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            
            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover a Empresa?')) {
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.delEmpresa(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {
                                    this.editedItem = {};
                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {
                    
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.addEmpresa(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>